import * as R from 'ramda'

import { toGrouped } from './to-grouped'

/**
 * Get amount of units
 * @param {number} ratio
 * @param {number} amount
 * @returns {number}
 */
function fromCents(ratio = 1, amount) {
  return amount / ratio
}

// currencySymbol :: * -> Boolean -> String -> [*]
function currencySymbol(symbol, prepend, amount) {
  const currencySet = prepend ? [symbol, amount] : [amount, symbol]

  return typeof symbol === 'string' ? currencySet.join(' ') : currencySet
}

/**
 * Format number as amount with currency
 * @param {string} currency Currency code according to ISO 4217
 * @param {number} amount Amount in cents
 * @param {("auto"|"show"|"hide")|boolean} [decimals="hide"] Decimal display type; "auto" hides decimals for round values
 * @returns {(string|any[])}
 *   String with formatted amount or tuple (array) containing amount and currency symbol if it’s non-string.
 * @example
 * function Balance(props) {
 *   return <div>{toAmount(props.currency, props.amount, true)}</div>
 * }
 */
// TODO: Use "auto" as default in next major release
export function toAmount(currency, amount, decimals = 'hide') {
  return R.pipe(
    // divide if necessary
    amount => fromCents(currency.ratio, amount),

    // add decimals if necessary
    amount => {
      if (process.NODE_ENV !== 'production' && typeof decimals === 'boolean') {
        // eslint-disable-next-line no-console
        console.warn(
          'DEPRECATED',
          '"decimals" parameter as boolean is deprecated; use "show", "hide" or "auto"'
        )
      }

      // TODO: remove support for Boolean in next major release
      const decimalsDisplay =
        typeof decimals === 'boolean' ? (decimals ? 'show' : 'hide') : decimals

      if (decimalsDisplay === 'show') {
        return amount.toFixed(2)
      } else if (decimalsDisplay === 'auto') {
        return amount === Math.floor(amount) ? amount : amount.toFixed(2)
      } else if (decimalsDisplay === 'hide') {
        return Math.floor(amount)
      }
    },

    // format the price, e. g. 10000 -> 10,000
    toGrouped,

    // add currency symbol
    amount => currencySymbol(currency.symbol, currency.prepend, amount)
  )(amount)
}
